import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { email } from './api';

// Aviso de e-mail novo em QUALQUER tela do Quality (fica no MainLayout): a cada 60 s pergunta ao servidor
// se chegou e-mail nas caixas da pessoa. Chegou → aviso no canto da tela, notificação do computador (se a
// pessoa permitiu), um "plim" baixinho e o nº de não lidos no menu (E-mail) e no título da aba.
// Quem não tem a tela de E-mail (403) para de perguntar.
const CHAVE_BASE = 'quality_email_uidnext';
const CHAVE_AVISADOS = 'quality_email_avisados';
const ler = (k, padrao) => { try { return JSON.parse(localStorage.getItem(k) || 'null') ?? padrao; } catch { return padrao; } };
const gravar = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* sem armazenamento */ } };

function plim() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(880, ctx.currentTime); o.frequency.exponentialRampToValueAtTime(1320, ctx.currentTime + 0.12);
    g.gain.setValueAtTime(0.0001, ctx.currentTime); g.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
    o.connect(g); g.connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.4);
    setTimeout(() => ctx.close(), 600);
  } catch { /* navegador sem áudio */ }
}

export default function AvisoEmail() {
  const navigate = useNavigate();
  const [avisos, setAvisos] = useState([]);
  const ativo = useRef(true);
  const tituloOriginal = useRef(document.title.replace(/^\(\d+\)\s*/, ''));

  useEffect(() => {
    let parar = false;
    const verificar = async () => {
      if (parar || !ativo.current) return;
      try {
        const base = ler(CHAVE_BASE, {});
        const r = await email('novos', { desde: base });
        const novaBase = { ...base };
        for (const c of r.caixas || []) if (c.uidNext) novaBase[c.contaId] = c.uidNext;
        gravar(CHAVE_BASE, novaBase);
        // nº de não lidos: menu lateral e título da aba
        window.dispatchEvent(new CustomEvent('quality-email-naolidas', { detail: r.naoLidas || 0 }));
        document.title = (r.naoLidas ? `(${r.naoLidas}) ` : '') + tituloOriginal.current;
        // e-mails novos (só os que nenhuma outra aba já avisou)
        const avisados = ler(CHAVE_AVISADOS, {});
        const agora = Date.now();
        for (const k of Object.keys(avisados)) if (agora - avisados[k] > 86400000) delete avisados[k];
        const novos = (r.chegaram || []).filter(m => !avisados[`${m.contaId}:${m.uid}`]);
        if (!novos.length) { gravar(CHAVE_AVISADOS, avisados); return; }
        novos.forEach(m => { avisados[`${m.contaId}:${m.uid}`] = agora; });
        gravar(CHAVE_AVISADOS, avisados);
        plim();
        setAvisos(a => [...novos.map(m => ({ ...m, id: `${m.contaId}:${m.uid}` })), ...a].slice(0, 3));
        novos.forEach(m => setTimeout(() => setAvisos(a => a.filter(x => x.id !== `${m.contaId}:${m.uid}`)), 12000));
        if (window.Notification && Notification.permission === 'granted') {
          for (const m of novos) {
            const n = new Notification(`✉️ ${m.de || 'Novo e-mail'}`, { body: `${m.assunto}\n${m.caixa}`, tag: `quality-email-${m.contaId}-${m.uid}`, icon: '/favicon-64.png' });
            n.onclick = () => { window.focus(); navigate('/email'); n.close(); };
          }
        }
      } catch (e) {
        if (/Sem acesso|403|Não autenticado|SESSAO_ENCERRADA/i.test(e.message || '')) { ativo.current = false; }
      }
    };
    const primeira = setTimeout(verificar, 4000);
    const t = setInterval(verificar, 60000);
    return () => { parar = true; clearTimeout(primeira); clearInterval(t); document.title = tituloOriginal.current; };
  }, [navigate]);

  if (!avisos.length) return null;
  return (
    <div style={{ position: 'fixed', right: 18, bottom: 18, zIndex: 3000, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 360 }}>
      {avisos.map(m => (
        <div key={m.id} role="status" style={{ background: '#fff', borderRadius: 12, boxShadow: '0 14px 34px -12px rgba(0,0,0,.35)', borderLeft: '4px solid #00897b', padding: '10px 12px', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          <span style={{ fontSize: 20 }}>✉️</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 11.5, color: '#00796b', fontWeight: 700 }}>Novo e-mail · {m.caixa}</div>
            <div style={{ fontWeight: 700, fontSize: 13.5, color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.de}</div>
            <div style={{ fontSize: 12.5, color: '#4b5563', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.assunto}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <button onClick={() => { setAvisos(a => a.filter(x => x.id !== m.id)); navigate('/email'); }} style={{ background: '#00897b', color: '#fff', border: 0, borderRadius: 7, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>Abrir</button>
            <button onClick={() => setAvisos(a => a.filter(x => x.id !== m.id))} style={{ background: 'none', color: '#6b7280', border: 0, fontSize: 11.5, cursor: 'pointer' }}>fechar</button>
          </div>
        </div>
      ))}
    </div>
  );
}
